import React, { useState, useRef } from 'react';

// Feuille d'invitation (bottom sheet) : QR code + code + copier le lien + partager.
// Réutilisable partout où on a un groupe avec un inviteCode. Extrait de l'ancienne
// page Groups. Props : group ({ name, inviteCode }), onClose.
export default function InviteSheet({ group, onClose }) {
  const [linkCopied, setLinkCopied] = useState(false);
  const inviteLinkRef = useRef(null);

  if (!group) return null;

  const getInviteUrl = (code) => `${window.location.origin}/rejoindre/${code}`;

  const handleCopyLink = async (code) => {
    try {
      await navigator.clipboard.writeText(getInviteUrl(code));
      setLinkCopied(true); setTimeout(() => setLinkCopied(false), 2500);
    } catch {
      if (inviteLinkRef.current) { inviteLinkRef.current.select(); document.execCommand('copy'); }
      setLinkCopied(true); setTimeout(() => setLinkCopied(false), 2500);
    }
  };

  const handleShare = async () => {
    const url = getInviteUrl(group.inviteCode);
    if (navigator.share) {
      try {
        await navigator.share({
          title: `Rejoins ${group.name} !`,
          text: `Je t'invite à rejoindre notre groupe de volley "${group.name}" sur Spike. Clique pour nous rejoindre !`,
          url,
        });
      } catch { /* annulé */ }
    } else {
      handleCopyLink(group.inviteCode);
    }
  };

  return (
    <div className="invite-overlay" onClick={onClose}>
      <div className="invite-sheet" onClick={e => e.stopPropagation()}>
        <div className="invite-sheet-handle"></div>
        <div className="invite-sheet-header">
          <div className="invite-sheet-icon" aria-hidden="true">👥</div>
          <h3 className="invite-sheet-title">Inviter dans<br />"{group.name}"</h3>
          <p className="invite-sheet-subtitle">Partagez le lien — vos amis pourront rejoindre directement.</p>
        </div>
        <div style={{ textAlign: 'center', margin: '12px 0 8px' }}>
          <img
            src={`https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=${encodeURIComponent(getInviteUrl(group.inviteCode))}&bgcolor=ffffff&color=1565C0&margin=6`}
            alt="QR code d'invitation"
            style={{ borderRadius: 12, border: '1px solid #E0E8F4', width: 160, height: 160 }}
          />
          <div style={{ fontSize: 11, color: '#90A0B0', marginTop: 6 }}>Scanner pour rejoindre directement</div>
        </div>
        <div className="invite-link-box" style={{ justifyContent: 'center', padding: '14px 12px', position: 'relative' }}>
          <span style={{ fontSize: 22 }} aria-hidden="true">🔗</span>
          <span style={{ fontSize: 22, fontWeight: 800, letterSpacing: 4, color: 'var(--primary)', fontFamily: 'monospace' }}>{group.inviteCode}</span>
          <input ref={inviteLinkRef} type="text" readOnly value={getInviteUrl(group.inviteCode)}
            style={{ position: 'absolute', opacity: 0, pointerEvents: 'none', width: 0, height: 0, overflow: 'hidden' }} />
        </div>
        <div className="invite-actions">
          <button className={`invite-btn invite-btn-copy ${linkCopied ? 'copied' : ''}`}
            onClick={() => handleCopyLink(group.inviteCode)}>
            <span className="invite-btn-icon" aria-hidden="true">{linkCopied ? '✓' : '📋'}</span>
            <span>{linkCopied ? 'Lien copié !' : 'Copier le lien'}</span>
          </button>
          <button className="invite-btn invite-btn-share" onClick={handleShare}>
            <span className="invite-btn-icon" aria-hidden="true">📤</span>
            <span>Partager via…</span>
            <span className="invite-btn-apps">WhatsApp · Messenger · Instagram…</span>
          </button>
        </div>
        <button className="invite-close" onClick={onClose}>Fermer</button>
      </div>
    </div>
  );
}
